import BackButton from "@/features/shared/components/back-button";
import { markdownQueryOptions } from "@/lib/markdown";
import { useQuery } from "@tanstack/react-query";
import { appTitleHead } from "@/lib/app-document-title";
import { createFileRoute } from "@tanstack/react-router";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import { useLng } from "@/hooks/use-lng";

export const Route = createFileRoute("/_app/accessibility")({
  head: () => appTitleHead("accessibility-title"),
  component: AccessibilityPage
});

function AccessibilityPage() {
  const lng = useLng();
  const { data: markdown, isLoading } = useQuery(markdownQueryOptions("accessibility", lng));

  return (
    <div className="accessibility-page mx-auto">
      <BackButton />
      <div className="prose prose-a:text-primary! prose-h1:text-foreground! prose-h2:text-foreground! prose-h3:text-foreground! prose-h4:text-foreground! prose-h5:text-foreground! prose-h6:text-foreground! prose-h2:mb-1 pt-4">
        {isLoading ? (
          <>Loading...</>
        ) : markdown ? (
          <ReactMarkdown rehypePlugins={[rehypeRaw]}>{markdown}</ReactMarkdown>
        ) : null}
      </div>
    </div>
  );
}
